export type ToastTone = "neutral" | "success" | "danger";

export function toast(message: string, tone: ToastTone = "neutral"): void {
  window.dispatchEvent(new CustomEvent("share-moments:toast", { detail: { message, tone } }));
}
